<template>
  <div>
    <el-dialog
      ref="editDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="报告类型">
                  <el-input
                    v-model="dialogViewForm.typeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="周期">
                  <el-input
                    v-model="dialogViewForm.period"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="报告名称">
                  <el-input
                    v-model="dialogViewForm.name"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="线下样本数量">
                  <el-input-number
                    v-model="dialogViewForm.sampleOfflineNum"
                    :precision="0"
                    :controls="false"
                    disabled
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="线上样本数量">
                  <el-input-number
                    v-model="dialogViewForm.sampleOnlineNum"
                    :precision="0"
                    :controls="false"
                    disabled
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="title">
              调研零售户档位分组占比数据
            </div>
            <el-row :gutter="10">
              <el-col
                v-for="(levelItem, levelIndex) in dialogViewForm.levelProportionDtoList"
                :key="'LevelProportion_' + levelIndex"
                :span="6"
              >
                <el-form-item :label="levelItem.levelGroupName">
                  <el-input
                    v-model="levelItem.proportion"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="整体策略">
                  <el-input
                    v-model="dialogViewForm.overallStrategy"
                    type="textarea"
                    :autosize="{ minRows: 4}"
                    disabled
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="风险预警">
                  <el-input
                    v-model="dialogViewForm.riskWarning"
                    type="textarea"
                    :autosize="{ minRows: 4}"
                    disabled
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            调研品规明细信息
          </h3>
          <div class="modal-row-box">
            <div
              v-for="(productItem, productIndex) in dialogViewForm.surveyProductDataList"
              :key="'ProductSurvey_' + productIndex"
            >
              <div class="title">
                {{ productItem.productName }}
              </div>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="批发价">
                    <el-input-number
                      v-model="productItem.wholesalePrice"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="最低集市交易价">
                    <el-input-number
                      v-model="productItem.marketMinPrice"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="集市交易价">
                    <el-input-number
                      v-model="productItem.marketPrice"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="环比">
                    <el-input
                      v-model="productItem.sequential"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="条零售价">
                    <el-input-number
                      v-model="productItem.orderPrice"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="包零售价">
                    <el-input-number
                      v-model="productItem.packagePrice"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="价格指数">
                    <el-input-number
                      v-model="productItem.priceIndex"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="价格状态">
                    <el-input
                      v-model="productItem.priceIndexValue"
                      disabled
                      :class="['status-input', getPriceIndexClass(productItem.priceIndexValue)]"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  v-for="(inventoryItem, inventoryIndex) in productItem.inventoryDataArray"
                  :key="'ProductInventory_' + inventoryIndex"
                  :span="6"
                >
                  <el-form-item :label="inventoryItem.levelGroupName + ' 平均库存'">
                    <el-popover
                      placement="bottom-start"
                      width="550"
                      trigger="hover"
                    >
                      <div v-if="inventoryItem.concentrationAnalysis">
                        <p style="width: 100%; text-align: center;">
                          库存集中度分析报告
                        </p>
                        <p
                          style="white-space: pre-wrap;"
                          v-text="inventoryItem.concentrationAnalysis"
                        />
                        <p>核心洞察:</p>
                        <p
                          style="white-space: pre-wrap;"
                          v-text="inventoryItem.coreInsights"
                        />
                      </div>
                      <div v-else>
                        <p style="width: 100%; text-align: center; margin: 20px 0; font-size: 16px; color: #F56C6C;">
                          无库存集中度分析报告数据
                        </p>
                      </div>
                      <el-button
                        slot="reference"
                        type="info"
                        plain
                        style="width: 100%"
                      >
                        {{ inventoryItem.inventory }}
                      </el-button>
                    </el-popover>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="动销情况：够卖">
                    <el-input-number
                      v-model="productItem.salesSituation1"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：不够卖">
                    <el-input-number
                      v-model="productItem.salesSituation2"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：卖的慢">
                    <el-input-number
                      v-model="productItem.salesSituation3"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：卖不动">
                    <el-input-number
                      v-model="productItem.salesSituation4"
                      :precision="0"
                      :controls="false"
                      disabled
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="动销情况：够卖(百分比)">
                    <el-input
                      v-model="productItem.salesSituation1Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：不够卖(百分比)">
                    <el-input
                      v-model="productItem.salesSituation2Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：卖的慢(百分比)">
                    <el-input
                      v-model="productItem.salesSituation3Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：卖不动(百分比)">
                    <el-input
                      v-model="productItem.salesSituation4Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="productItem.opinionDataArray && productItem.opinionDataArray.length > 0"
                :gutter="10"
                class="opinion-tag"
              >
                <el-form-item label="零售户意见">
                  <el-col
                    v-for="(opinionItem, opinionIndex) in productItem.opinionDataArray"
                    :key="'opinion_' + opinionIndex"
                    :span="6"
                  >
                    <el-tag
                      type="primary"
                      size="medium"
                      effect="plain"
                      style="width: 100%; text-align: center;"
                    >
                      {{ opinionItem.label }} ({{ opinionItem.data }})
                    </el-tag>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="市场动态">
                    <el-input
                      v-model="productItem.marketDynamicsDesc"
                      type="textarea"
                      :autosize="{ minRows: 4}"
                      disabled
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="投放建议">
                    <el-input
                      v-model="productItem.marketLaunchSuggest"
                      type="textarea"
                      :autosize="{ minRows: 4}"
                      disabled
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="库存分布健康评价">
                    <el-input
                      v-model="productItem.distributionHealth"
                      type="textarea"
                      :autosize="{ minRows: 4}"
                      disabled
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-divider v-if="productIndex < dialogViewForm.surveyProductDataList.length - 1" />
            </div>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            市场动态内容
          </h3>
          <div class="modal-row-box">
            <el-row>
              <el-col :span="24">
                <div class="market-dynamics-content">
                  {{ dialogViewForm.marketDynamics }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin';
import { viewMarketReportApi } from '@/api/v2/marketReport';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogViewForm: {},
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;
        _this.dialogViewForm = {};
        _this.loadMarketReportData();

        _this.$nextTick(() => { })
      }
    }
  },
  methods: {
    // 获取市场报告数据
    loadMarketReportData() {
      let _this = this
      viewMarketReportApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogViewForm = data;
        _this.dialogViewForm.period = data.periodName + ' [' + data.startDate + '~' + data.endDate + ']';
        _this.dialogViewForm.surveyProductDataList = data.reportPriceDtoList || [];

        let inventoryDataArray = data.inventoryDtoList || [];

        // 把库存数据封装成KEY为品规ID，VALUE为各档位分组库存的MAP
        let inventoryDataMap = inventoryDataArray.reduce((acc, cur) => {
          if (!acc[cur.productId]) {
            acc[cur.productId] = []
          }
          acc[cur.productId].push(cur)
          return acc
        }, {});

        _this.dialogViewForm.surveyProductDataList.forEach((item) => {
          item.inventoryDataArray = inventoryDataMap[item.productId] || [];
          item.opinionDataArray = item.opinionData ? JSON.parse(item.opinionData) : [];
        })

      })
    },
    // 价格指数样式
    getPriceIndexClass(value) {
      const classMap = {
        '异常': 'status-danger',
        '低': 'status-warning',
        '正常': 'status-info',
        '良好': 'status-primary',
        '优异': 'status-success'
      }
      return classMap[value] || ''
    },
    modalClose() {
      let _this = this
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: 800;
  color: #409eff;
  margin: 8px 0;
}

.status-input {
  &.status-danger {
    ::v-deep .el-input__inner {
      color: #f56c6c;
      font-weight: bold;
    }
  }
  &.status-warning {
    ::v-deep .el-input__inner {
      color: #e6a23c;
      font-weight: bold;
    }
  }
  &.status-info {
    ::v-deep .el-input__inner {
      color: #4a4c4c;
    }
  }
  &.status-primary {
    ::v-deep .el-input__inner {
      color: #409eff;
      font-weight: bold;
    }
  }
  &.status-success {
    ::v-deep .el-input__inner {
      color: #67c23a;
      font-weight: bold;
    }
  }
}

::v-deep .el-divider {
  background-color: #6aa1ce;
}

::v-deep .el-divider--horizontal {
  margin: 12px 0 16px 0;
}

.opinion-tag {
  .el-col {
    min-height: 28px;
    padding: 5px;
  }
}

.market-dynamics-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.6;
  padding: 5px 16px;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #606266;
  min-height: 100px;
  margin: 5px 0;
}
</style>
